import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { PhotoIcon } from "@heroicons/react/20/solid";

export default function AvatarUpload({ url, size, onUpload }) {
  const { supabase } = useContext(AuthContext);
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (url) downloadImage(url);
  }, [url]);

  async function downloadImage(filename) {
    try {
      const { data } = supabase.storage
        .from("avatars")
        .getPublicUrl(`${filename}`);
      setAvatarUrl(url);
    } catch (error) {
      console.log("Error downloading image: ", error.message);
    }
  }

  async function uploadAvatar(event) {
    try {
      setUploading(true);

      if (!event.target.files || event.target.files.length === 0) {
        throw new Error("You must select an image to upload.");
      }

      const file = event.target.files[0];
      const filePath = `${file.name}`;

      const { data, error: uploadError } = await supabase.storage
        .from("avatars")
        .upload(filePath, file);

      if (uploadError) {
        throw uploadError;
      }

      console.log({ data, filePath });
      onUpload(event, filePath);
    } catch (error) {
      alert(error.message);
    } finally {
      setUploading(false);
    }
  }

  return (
    <div
      style={{ width: size, height: size }}
      className="relative  rounded-full overflow-hidden"
    >
      <input
        className="cursor-pointer rounded-full overflow-hidden"
        style={{
          width: size,
          height: size,
          opacity: 0,
          top: 0,
          left: 0,
          position: "absolute",
        }}
        type="file"
        id="single"
        accept="image/*"
        onChange={uploadAvatar}
        disabled={uploading}
      />

      {avatarUrl ? (
        <img
          src={
            "https://dizfqywncoihpuevvmpp.supabase.co/storage/v1/object/public/avatars/" +
            avatarUrl
          }
          alt="Avatar"
          className="avatar image"
          style={{ height: size, width: size }}
        />
      ) : (
        <div
          className="avatar no-image bg-gray-100 border border-gray-300 flex items-center justify-center rounded-full"
          style={{ height: size, width: size }}
        >
          <PhotoIcon className="text-gray-300" style={{ width: "40%" }} />
        </div>
      )}
    </div>
  );
}
